import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProductGrid from "@/components/ProductGrid";
import Manifesto from "@/components/Manifesto";
import InstagramGallery from "@/components/InstagramGallery";
import Footer from "@/components/Footer";
import CartSheet from "@/components/CartSheet";
import FloatingContact from "@/components/FloatingContact";

export default function Home() {
  return (
    <div className="bg-cream" data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <ProductGrid />
      <Manifesto />
      <InstagramGallery />
      <Footer />
      <CartSheet />
      <FloatingContact />
    </div>
  );
}
